import React, { FC, useEffect, useState } from 'react';
import { getProfileAvatarUrl, PROFILE_AVATAR_FALLBACK } from 'store/services/URL';

type ProfileAvatarProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
  profile?: string | null;
};

const ProfileAvatar: FC<ProfileAvatarProps> = ({
  profile,
  alt = 'profile',
  onError,
  ...rest
}) => {
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    setImgError(false);
  }, [profile]);

  const handleError = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
    setImgError(true);
    onError?.(event);
  };

  return (
    <img
      {...rest}
      src={imgError ? PROFILE_AVATAR_FALLBACK : getProfileAvatarUrl(profile)}
      alt={alt}
      onError={handleError}
    />
  );
};

export default ProfileAvatar;
